import styled from '@emotion/styled';

import { mypageFormContainerCss, mypageSubPageTitleCss } from '@/components/MyPage/shared/subPageStyles';

export const FormContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4.4rem;
	max-width: 44rem;
	width: 100%;
	margin: 0 auto;
	${mypageFormContainerCss}
`;
export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
`;
export const Title = styled.h2`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	${mypageSubPageTitleCss}
`;
export const FormGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;
export const Label = styled.label`
	font-size: 1.4rem;
	color: #212529;
	font-weight: 700;
	display: flex;
	align-items: center;
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;
export const CertState = styled.p`
	font-weight: 400;
	font-size: 1.6rem;
	line-height: ${(props) => props.theme.lineHeight.tight};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	&.normal {
		color: #16a34a;
	}
	&.error {
		color: #dc2626;
	}
`;
export const EditButton = styled.button`
	background-color: transparent;
	color: #212529;
	height: 4.4rem;
	padding: 0 1.2rem;
	border: none;
	cursor: pointer;
	border: 1px solid #212529;
	&:disabled {
		border: 1px solid #adb5bd;
		color: #adb5bd;
		cursor: auto;
	}
`;
